import { Component, inject } from '@angular/core';
import { Router, NavigationEnd, RouterLink, RouterLinkActive } from '@angular/router';
import { Auth } from '../app/services/auth/auth';
import { CommonModule } from '@angular/common';
import { addIcons,  } from 'ionicons';
import { mailOutline, mailSharp, paperPlaneOutline, paperPlaneSharp,
   heartOutline, heartSharp, archiveOutline, archiveSharp, trashOutline, trashSharp, warningOutline, warningSharp,
    bookmarkOutline, bookmarkSharp,
    walletOutline, personOutline,
    statsChartOutline,
     settingsOutline, logOutOutline,
     addCircleOutline ,
    homeOutline, home,
      searchOutline, search,
     heart,
       person,
      addOutline, 
      carOutline,
      carSportOutline,
      calendarOutline
  } from 'ionicons/icons';
import { filter } from 'rxjs/operators';

// Componentes standalone de Ionic
import { IonApp, IonSplitPane, IonMenu, IonContent, IonList, IonListHeader, 
  IonNote, IonMenuToggle, IonItem, IonIcon, IonLabel, IonRouterOutlet, IonRouterLink,
  IonHeader, IonToolbar, IonTitle, // << Faltaban estos tres
  IonTabs, IonTabBar, IonTabButton,
  IonButtons, IonMenuButton, 
  IonPopover
  
} from '@ionic/angular/standalone';
import { Notification } from './services/notifications/notification'; // Ajusta la ruta si es necesario
import { TranslatePipe, TranslateService } from '@ngx-translate/core'; // 👈 1. Importar el Pipe

@Component({
  selector: 'app-root',
  standalone: true,
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
  imports: [
    CommonModule, // << esto incluye NgIf y NgFor
    RouterLink,
    RouterLinkActive,
    IonApp,
    IonSplitPane,
    IonMenu,
    IonContent,
    IonList,
    IonListHeader,
    IonNote,
    IonMenuToggle,
    IonItem,
    IonIcon,
    IonLabel,
    IonRouterLink,
    IonRouterOutlet,
    IonTitle,
    IonToolbar,
    IonHeader,
    IonTabs,
    IonTabBar,
    IonTabButton,
    IonHeader, IonToolbar, IonButtons, IonMenuButton, 
    IonTitle, IonIcon, IonPopover, IonContent, IonList, IonItem, IonLabel,TranslatePipe
  ],
})
export class AppComponent {
  private translate = inject(TranslateService);
  public hiddenRoutes = ['/', '/register','/forgot-password'];

  public appPages = [
    { title: 'Inbox', url: '/folder/inbox', icon: 'mail' },
    { title: 'Outbox', url: '/folder/outbox', icon: 'paper-plane' },
    { title: 'Favorites', url: '/folder/favorites', icon: 'heart' },
    { title: 'Archived', url: '/folder/archived', icon: 'archive' },
    { title: 'Trash', url: '/folder/trash', icon: 'trash' },
    { title: 'Spam', url: '/folder/spam', icon: 'warning' },
  ];

  public showSidebar = false;
  public showTab = false;

  public labels = ['Family', 'Friends', 'Notes', 'Work', 'Travel', 'Reminders'];

  constructor(private router: Router,
    public authService: Auth, 
    private notificationService: Notification
  ) {
    addIcons({
      mailOutline, mailSharp, paperPlaneOutline, paperPlaneSharp, heartOutline, heartSharp,
      archiveOutline, archiveSharp, trashOutline, trashSharp, warningOutline, warningSharp,
      bookmarkOutline, bookmarkSharp,
      walletOutline, 
      personOutline,
      statsChartOutline,
      homeOutline, home,
      searchOutline, search,
      heart,
      person,
      addOutline,
      settingsOutline,
      logOutOutline,
      addCircleOutline,
      carSportOutline,
      calendarOutline
      
    });


    this.router.events
    .pipe(filter(event => event instanceof NavigationEnd))
    .subscribe((event: any) => {
      const url = event.urlAfterRedirects;

      const isPublicPage = url === '/' || url === '/login' || url === '/forgot-password' || url.includes('/register');

      const noShowTabs =  url === '/login' || url.includes('/login');
      this.showTab = !noShowTabs
      this.showSidebar = !isPublicPage;

    });
    this.translate.use('ES');
  }
  goToSettings() {
    this.router.navigate(['/profile']);
  }

  logout() {
  
    try {
      localStorage.removeItem('auth_token');

  
      this.showSidebar = false;
      this.showTab = false;
  
      this.router.navigate(['/login']);
  
    } catch (error) {
      console.error('Error durante el cierre de sesión:', error);
      this.notificationService.error('Ocurrió un error al cerrar la sesión');
    }
  }


  
}